import { Icon } from './Icon';
import { cx } from '@/lib/cx';

interface SpinnerProps {
  label?: string;
  className?: string;
}

/** A polite live region, so screen readers hear that something is loading. */
export function Spinner({ label = 'Loading', className }: SpinnerProps) {
  return (
    <span role="status" className={cx('inline-flex items-center gap-2 text-ink-soft', className)}>
      <Icon name="spinner" className="h-5 w-5 text-accent" />
      <span className="text-sm">{label}</span>
    </span>
  );
}

interface SkeletonProps {
  className?: string;
}

/** A placeholder block; decorative, pair it with a Spinner or aria-busy on the container. */
export function Skeleton({ className }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={cx('block animate-pulse rounded bg-surface-2', className)}
    />
  );
}
